import {
  RECEIVE_STEP,
  SET_BAR_STATE,
} from '../actions/stepsActions';

const initialState = {
  step: 1, // 1 = identificaçāo / 2 = pagamento / 3 = conclusāo
  path: '',
  barBackOpen: false,
};

export default function StepsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_STEP:
      return {
        ...state, step: action.step, path: action.path
      };
    case SET_BAR_STATE:
      return {
        ...state, barBackOpen: action.state
      };
    default:
      return state;
  }
}
